import { TOAST_ADD, TOAST_REMOVE } from './constants'

const initialState = {
  items: [],
}

export default (state = initialState, action) => {
  switch (action.type) {
    case TOAST_ADD:
      return {
        ...state,
        items: [
          {
            ...action.toast,
            date: new Date(),
          },
          ...state.items,
        ],
      }
    case TOAST_REMOVE:
      return {
        ...state,
        items: state.items.filter((elem) => elem.id !== action.toast.id),
      }
    default:
      return state
  }
}
